import React from "react";
import Joyride from "react-joyride";
import { useDispatch } from "react-redux";

const TourGuide = ({steps, handleNext, stepIndex, toolTipRun, backgroundClr, textClr}) => {
  const dispatch = useDispatch();

  const handleJoyrideCallback = (data) => {
        if (data.action === "next") {
          dispatch({ type: "TOOLTIP_TOUR_NEXT_STEP", payload: { toolTipstepIndex: stepIndex + 1 } });
        }
        if (data.status === "finished" || data.status === "skipped") {
          // setRunTooltip(false);
        }
      };
  return(<>
  <Joyride
      steps={steps}
        stepIndex={stepIndex} 
        run={toolTipRun}
        continuous={true}
        showSkipButton={false}
        key={stepIndex}
        callback={handleJoyrideCallback}
        scrollToFirstStep={true}
        scrollDuration={300}
        scrollOffset={100}
        spotlightClicks={false}
        disableOverlay={false}
        disableInteraction={true}
        styles={{
          options: {
            arrowColor: backgroundClr,
            backgroundColor: backgroundClr,
            textColor: textClr,
            padding: 15,
            borderRadius: "20px",
          },
          tooltip: {
            backgroundColor: backgroundClr,
            width: "205px",
            textAlign: "center",
            color: textClr,
          },
          buttonClose: {
            display: "none", 
          },
          buttonBack: {
            display: "none", 
          },
          buttonNext: {
            display: "none", 
          },
          tooltipContainer: {
            color: textClr,
          },
        }}
  />
  </>)
}

export default TourGuide;
